/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Grower_Report_Col_TotalInputs */

const vi_my_grower_report_col_total = /** @type {(inputs: My_Grower_Report_Col_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng`)
};

/**

* @param {My_Grower_Report_Col_TotalInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const my_grower_report_col_total = /** @type {((inputs?: My_Grower_Report_Col_TotalInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Grower_Report_Col_TotalInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_my_grower_report_col_total(inputs)
});